import React, { Fragment } from "react";
import { createInterpolateElement } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { HorizontalLine } from "../components/horizontal-line";
import { PluginsPro } from "../components/plugins";
import { Features } from "../components/features";
import { Services } from "../components/services";
import { Section } from "../components/section";
import { Button } from "../components/button/button";
import { getUtmUrl } from "../utils/utm-url";

const ctaContent = createInterpolateElement(
  __(
    "Find your plan (From $3/m <highlight>$15/m</highlight>)",
    "plugin-cross-sell-textdomain"
  ),
  {
    highlight: <span className="cross-sell-highlighted-price" />,
  }
);

const ProContent = () => {
  return (
    <Fragment>
      <Section
        title={__(
          "Did you know WPMU DEV Membership includes ",
          "plugin-cross-sell-textdomain"
        )}
        titleUnderline={__(
          "ALL our Pro Plugins?",
          "plugin-cross-sell-textdomain"
        )}
        description={__(
          "Plus, everything your agency needs for hosting, reselling and more.",
          "plugin-cross-sell-textdomain"
        )}
        className="cross-sell-section-membership"
      >
        <div className="cross-sell-site">
          <Button as="a" href={getUtmUrl("https://wpmudev.com/pricing/", {utm_campaign:'cross-sell_top-cta'})} target="_blank">
            {ctaContent}
          </Button>
        </div>
      </Section>
      <HorizontalLine />
      <PluginsPro />
      <HorizontalLine />
      <Features />
      <HorizontalLine />
      <Services />
      <Section
        title={__(
          "Your comprehensive toolkit for WordPress website management.",
          "plugin-cross-sell-textdomain"
        )}
      >
        <div className="cross-sell-site">
          <Button as="a" href={getUtmUrl("https://wpmudev.com/pricing/", {utm_campaign:'cross-sell_bottom-cta'})} target="_blank">
            {ctaContent}
          </Button>
          <span className="cross-sell-site-text cross-sell-text-center">
            {__(
              "30 day guarantee: If you don’t love it, we’ll give you your money back - no questions asked.",
              "plugin-cross-sell-textdomain"
            )}
          </span>
        </div>
      </Section>
    </Fragment>
  );
};

export { ProContent };
